module.exports = __webpack_public_path__ + "LatoLatin-Black.ad3a6cf7d73d0ee8746a.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Black.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Black.eot
// module chunks = styles